import { useEffect, useState } from "react";
import api from "@/lib/api";

export const REACTION_EMOJI = ["❤️", "😂", "🔥", "👏", "😢", "😱", "🎬", "🙌"];

export const ReactionBar = ({ token, onSent }) => {
  const send = async (emoji) => {
    try {
      const { data } = await api.post(`/watch-party/${token}/reaction`, { emoji });
      onSent?.(data);
    } catch { /* ignore — party may have ended */ }
  };
  return (
    <div className="flex items-center justify-between gap-1 px-3 py-2 border-t border-white/10 shrink-0" data-testid="wp-reaction-bar">
      {REACTION_EMOJI.map((e, i) => (
        <button
          key={e}
          type="button"
          onClick={() => send(e)}
          className="w-8 h-8 rounded-full text-lg hover:bg-white/10 active:scale-90 transition-transform"
          aria-label={`React ${e}`}
          data-testid={`wp-reaction-${i}`}
        >
          {e}
        </button>
      ))}
    </div>
  );
};

export const StatusPill = ({ status, watching }) => {
  const live = status === "live";
  const label = live ? "Live" : status === "ended" ? "Ended" : "Reconnecting…";
  return (
    <span className="flex items-center gap-2 text-[11px] text-foreground/60" data-testid="wp-connection-status" data-status={status}>
      <span className={`w-2 h-2 rounded-full ${live ? "bg-emerald-400 animate-pulse" : "bg-gold"}`} />
      {label}
      {watching != null && <span className="text-foreground/50" data-testid="wp-watching-count">· {watching} watching</span>}
    </span>
  );
};

export const FloatingReactions = ({ latest }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!latest) return undefined;
    const item = { key: latest.key, emoji: latest.message, name: latest.sender_name, left: 10 + Math.random() * 70 };
    setItems((prev) => [...prev.slice(-12), item]);
    const t = setTimeout(() => setItems((prev) => prev.filter((x) => x.key !== item.key)), 3200);
    return () => clearTimeout(t);
  }, [latest]);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-20" data-testid="wp-floating-reactions">
      {items.map((x) => (
        <div key={x.key} className="wp-float absolute bottom-16 flex flex-col items-center" style={{ left: `${x.left}%` }}>
          <span className="text-4xl drop-shadow-lg">{x.emoji}</span>
          <span className="text-[10px] text-white/80 bg-black/40 rounded-full px-2 mt-1">{x.name}</span>
        </div>
      ))}
    </div>
  );
};
